import { render, staticRenderFns } from "./IconFlagVerify.vue?vue&type=template&id=c8c211e2&"
import script from "./IconFlagVerify.vue?vue&type=script&lang=js&"
export * from "./IconFlagVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports